import { useMemo } from 'react'
import { useTranslations } from 'next-intl'

import { useDestinationContext } from '@/src/contexts'
import CategoryFaq from '@/src/components/common/srp/flightSchedule/routeSeoContent/categoryFaq/categoryFaq'
import type { GroupedFaqCategory } from '@/src/components/common/srp/flightSchedule/routeSeoContent/categoryFaq/categoryFaq'

const DestinationFaqWrapper = () => {
    const t = useTranslations('destinationPage')
    const { destinationData: { sections } } = useDestinationContext()
    const faq = sections.faq
    if (!faq?.length) return null

    const groupedFaq: GroupedFaqCategory[] = useMemo(() => {
        const map = new Map<string, { categoryLabel?: string; items: { question: string; answer: string }[] }>()
        for (const item of faq) {
            const existing = map.get(item.category)
            if (existing) {
                existing.items.push({ question: item.question, answer: item.answer })
            } else {
                map.set(item.category, { categoryLabel: item.categoryLabel, items: [{ question: item.question, answer: item.answer }] })
            }
        }
        return Array.from(map, ([category, { categoryLabel, items }]) => ({ category, categoryLabel, items }))
    }, [faq])

    return <CategoryFaq title={t('faq')} groupedFaq={groupedFaq} />
}

export default DestinationFaqWrapper
